import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import SimplePagination from "./SimplePagination";
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class ProvidersInvitationsPanel extends Component {
    static contextType = LangContext;
    constructor(props) {

        super();
        const defaultLang = this.context || { get: () => {} }; // Asume que lang tiene un método 'get'

        this.state = {

            all: [],
            statuses: [],
            status: 'Invitado',
            statusDossiers: null,
            search:'',
            page: 1,
            total: 0,
            maxRecords: props.top,
            orderBy : {value: 'date', dir: 'desc', text: '' },
            orderOptions : [ ],
        };
        this.loadStatus = this.loadStatus.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
    }

    changeOrderOption(option){
        this.setState({orderBy: option}, function(){
            this.getAll();
        });
    }

    componentDidMount() {
        const { lang } = this.context;

        // Actualiza el estado con el valor de lang


        const translatedOrderOptions = [
            { value: 'date', dir: 'desc', text: lang.get('messages.por_fecha__mas_recientes') },
            { value: 'date', dir: 'asc', text: lang.get('messages.por_fecha__mas_antiguos') },
            { value: 'fiscal_name', dir: 'asc', text: lang.get('messages.por_nombre_a__z') },
            { value: 'fiscal_name', dir: 'desc', text: lang.get('messages.por_nombre_z__a') },
        ];

        // Actualiza el estado con los textos traducidos
        this.setState({
            orderBy: translatedOrderOptions[0],  // Puedes establecer uno por defecto si es necesario
            orderOptions: translatedOrderOptions,
        });

        this.getStatuses()
        this.getAll()
    }

    handleChange(e){
        this.setState({all: [], search: e.target.value, page: 1}, function () {
            this.getAll();
        });
    }

    updateCurrentPage(page){
        this.setState({page: page}, function () {
            this.getAll();
        });
    }

    async getStatuses(){
        const res = await axios.get('/api/invitations/status')
        const data = res.data;
        this.setState({statuses: data});

        var statusDossiers = [];
        this.state.statuses.map((s) => {
            statusDossiers = [...statusDossiers, []];
        });
        this.setState({statusDossiers: statusDossiers})
    }

    showAll(){
        this.setState({all: [], page: 1, status: null, index: null}, () => {
            this.getAll();
        });
    }

    loadStatus(index){
        const status = this.state.statuses[index];
        this.setState({all: [], page: 1, status: status.id}, () => {
            this.getAll();
        });
    }

    async getAll(){
        var url = '/api/clients/invitations';
        const query = new URLSearchParams();
        query.append('page', this.state.page)
        query.append('maxRecords', this.state.maxRecords)
        if(this.state.search!=''){
            query.append('search', this.state.search)
        }
        if(this.state.status!=null){
            query.append('status', this.state.status);
        }

        if(this.state.orderBy.value != ''){
            query.append('orderBy', this.state.orderBy.value);
            query.append('orderByDir', this.state.orderBy.dir);
        }

        const qs = query.toString();
        url = url + `?${qs}`;
        url = url.endsWith('/') ? url.slice(0, -1) : url;

        const res = await axios.get(url);
        const data = res.data.data;
        this.setState({all: data, total: res.data.total});
    }

    getDossierTypeColor(type_id){
        if(type_id == 1) return 'danger'; // Nacional
        if(type_id == 2) return 'success'; // Internacional
        if(type_id == 3) return 'info'; // Especiales
        if(type_id == 4) return 'warning'; // Otros
    }

    confirmDelete = (id)=>{
        swal.fire({
            text: "¿Estás seguro que deseas eliminar esta invitación?",
            input: 'textarea',
            inputLabel: 'Motivo de eliminación (opcional)',
            inputPlaceholder: 'Captura el motivo de la eliminación',
            showCancelButton: true,
            icon: "question",
            buttonsStyling: false,
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
            customClass: {
                confirmButton: "btn font-weight-bold btn-danger",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                this.deleteInvitation(id, result.value || '');
            }
        });
    }

     deleteInvitation = (id, deletionReason = '') => {
        window.blockUI();
          axios.delete(
            '/api/persons/invitation/' + id,
            {
                data: {
                    deletion_reason: deletionReason,
                },
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            window.unblockUI();
            this.getAll();

            swal.fire({
                text: getSuccessMessage(response),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            });
        })
        .catch((error) => {
            window.unblockUI();
            swal.fire({
                text: 'Algo salió mal, intenta de nuevo',
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
        });
    }

    render() {
        const { lang } = this.context;
        return (
            <>
            <div className="card card-custom gutter-b my-5">
                <div className="card-header border-0 pt-7">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder font-size-h4 text-dark-75">{lang.get('messages.invitaciones')}</span>
                        <span className="text-muted mt-3 font-weight-bold font-size-sm">{this.state.total} {lang.get('messages.invitaciones_solicitadas')}.</span>
                    </h3>
                    <div className="card-toolbar">
                        <div>
                            {this.props.dashboard=="false" &&
                                <div className="input-icon mb-4">
                                    <input
                                        style={{width: '400px'}}
                                        onChange={this.handleChange}
                                        name="search"
                                        type="text"
                                        className="form-control"
                                        placeholder={lang.get('messages.buscar_invitaciones')} />
                                    <span>
                                        <i className="flaticon2-search-1 text-primary icon-md"></i>
                                    </span>
                                </div>
                            }
                            <ul className="nav nav-pills nav-pills-sm nav-dark justify-content-end">
                                {this.state.statuses.map((status, i) => {
                                    return <li key={i} className="nav-item ml-0" onClick={() => this.loadStatus(i)} >
                                        <a href={"#ts_" + i } className={`nav-link py-2 px-4 font-weight-bolder  text-white font-size-sm ${this.state.status==status.id ? "active" : "text-dark-50"}`}>{lang.get('messages.'+status.name.toLowerCase())}</a>
                                    </li>
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="card-body pt-1">
                    {this.props.dashboard=="false" &&
                        <div className="dropdown text-right">
                            <button className="btn btn-secondary btn-sm dropdown-toggle text-primary" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {lang.get('messages.ordenar')} {this.state.orderBy.text}
                            </button>
                            <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                {this.state.orderOptions.map((option, i) => {
                                    return <a onClick={() => this.changeOrderOption(option)} key={i} className="dropdown-item" href="#">{ option.text }</a>
                                })}
                            </div>
                        </div>
                    }
                    <div className="table-responsive">
                        <table className="table table-borderless table-vertical-center">
                            <tbody>
                                {this.state.all.map((d, index) => {
                                    return <tr key={index}>
                                        <td className="pl-0 py-5" style={{ width : '20px' }}>
                                        {this.props.dashboard=="false" &&
                                            <div className="symbol symbol-40">
                                            <div className={"symbol-label text-white font-weight-bolder bg-"+this.getDossierTypeColor(d.dossier?.dossier_type_id)}>
                                                { d.dossier?.target.name[0] }
                                            </div>
                                        </div>
                                        }
                                        {this.props.dashboard=="true" &&
                                            <div className="symbol symbol-40">
                                            <div className={"symbol-label text-white font-weight-bolder bg-"+this.getDossierTypeColor(d.dossier?.dossier_type_id)}>
                                            { d.dossier?.target.name[0] }
                                            </div>
                                        </div>
                                        }
                                        </td>
                                        <td className="text-left">
                                            <a href={d.dossier?.status === 'Draft' ? "/providers/invitation/" + d.id + "/draft" : "/invitation/" + d.id}>
                                                <div className="text-dark-75 font-weight-bolder font-size-lg">
                                                    { d.name }
                                                </div>
                                                <span className="text-dark-50 font-weight-bold font-size-sm">{d.identity}: {d.rfc.toUpperCase()}
                                                {d.internal_id != null && <> | No. {lang.get('messages.interno')} {d.internal_id} </>}
                                                </span>
                                            </a>
                                        </td>
                                        <td>
                                            <span className="text-dark-50 font-weight-bold">{d.dossier?.title}</span>
                                        </td>
                                        <td className="text-left text-nowrap" style={{width:'1px'}}>
                                            <a href={d.dossier?.status === 'Draft' ? "/providers/invitation/" + d.id + "/draft" : "/invitation/" + d.id}>
                                                <span className="text-dark-75 font-weight-bolder mb-1 font-size-lg">{d.dossier?.total}</span>
                                                <span className="text-muted font-weight-bold ml-4">{lang.get('messages.documentos')}</span>
                                            </a>
                                        </td>
                                        <td className="text-right">
                                            {this.state.status !== 'Eliminadas' && ( d.dossier?.status == 'Invitado' &&  this.props.permissions.providers.includes('all') || this.props.permissions.providers.includes('delete_invitations') ) && this.props.dashboard=="false" &&
                                            <>
                                                <a onClick={()=>{ this.confirmDelete(d.id) }} className="btn btn-xs btn-icon btn-light-secondary mr-4">
                                                    <i className="flaticon-delete fw-normal text-primary"></i>
                                                </a>
                                            </>
                                            }
                                            <a href={d.dossier?.status === 'Draft' ? "/providers/invitation/" + d.id + "/draft" : "/invitation/" + d.id}>
                                                <button className="btn btn-icon btn-light btn-xs">
                                                    <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                </button>
                                            </a>
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>

                    { this.props.dashboard == "true" ?
                        <div className="text-right">
                            <a className="text-primary" href="/clients/invitations">{lang.get('messages.ver_todos')}</a>
                        </div>
                    :
                        <div></div>
                    }
                </div>
                {this.state.total > this.state.maxRecords && this.props.dashboard=="false" &&
                    <SimplePagination
                    updateCurrentPage={this.updateCurrentPage}
                    currentPage={this.state.page}
                    totalFiles={this.state.total}
                    split={this.state.maxRecords} />
                }
            </div>
            </>
        );
    }
}

export default ProvidersInvitationsPanel;

if (document.getElementById('ProvidersInvitationsPanel')) {
    ReactDOM.render(<ProvidersInvitationsPanel />, document.getElementById('ProvidersInvitationsPanel'));
}
